import { entitiyservices } from '../services.url';

export const ENTITIES_API = {
  GET_LIGHT_ENTITY_BY_PARENT: function (parentId: string) {
    return `${entitiyservices}/entities/lightweight?parentId=${parentId}`;
  },
};
